import { TEASPlans } from '../../types';

export const getEASPlanList = (easPlans: TEASPlans): string[] => {
  return easPlans.categories
    ?.map((category) => category.plans.map((plan) => plan.plan_id))
    .flat();
};
